module.exports = ['$resource', function ($resource) {

    const BroadcastRepetition = $resource('/broadcastrepetitions/:id',
        {
            id: '@id',
        },
        {
            'save': { method: 'POST' },
            'update': { method: 'PATCH' },
        }
    )

    const save = BroadcastRepetition.save

    // Required for "easy" .save in controllers
    BroadcastRepetition.save = function (...args) {
        if (args[0].id) {
            this.update.apply(this, args)
        } else {
            save.apply(this, args)
        }
    }

    return BroadcastRepetition
}]
